<template>
	<div class="base-main-content">
		<div class="base-title text-overflow word-shadow">{{ formatIrName }}</div>
		<div v-if="getIrSlogan" class="base-slogan mt-4">
			<div class="word-shadow text-overflow">
				{{ formatIrSlogan }}
			</div>
		</div>
		<div v-if="composeInfoAbout.length" class="base-info mt-10">
			<div v-for="(item, index) in composeInfoAbout" :key="index" class="base-info-item block-shadow">
				<span>{{ item }}</span>
			</div>
		</div>
	</div>
</template>

<script setup>
import { useBrandHeader } from '@rebuild/materials/shared/brand_header/useBrandHeader';

const { getIrSlogan, composeInfoAbout, formatIrName, formatIrSlogan } = useBrandHeader();
</script>

<style lang="less" scoped>
.word-shadow {
	text-shadow: 0px 0.04rem 0.1rem rgba(0, 0, 0, 0.05);
}
.block-shadow {
	box-shadow: 0 0.04rem 0.1rem 0 rgba(0, 0, 0, 0.05);
}

.base-main-content {
	margin-top: 0.2rem;
	margin-left: 0.78rem;
	min-height: 0.74rem;
	display: flex;
	flex-wrap: wrap;

	.base-title {
		max-width: 80%;
		color: #fff;
		/* 20/H2-medium */
		font-family: 'PingFang SC';
		font-size: 0.2rem;
		font-style: normal;
		font-weight: 500;
		line-height: 140%; /* 28px */
	}
	.base-slogan {
		width: 100%;
		font-size: 0;

		div {
			color: #fff;
			/* 11/B2-regular */
			font-family: 'PingFang SC';
			font-size: 0.11rem;
			font-style: normal;
			font-weight: 400;
			line-height: 140%; /* 15.4px */
		}
	}
	.base-info {
		width: 100%;
		font-size: 0;
	}
	.base-info-item {
		padding: 0 0.06rem;
		display: inline-block;
		height: 0.17rem;
		line-height: 0.17rem;
		border-radius: 0.01rem;
		background: rgba(255, 255, 255, 0.2);
		backdrop-filter: blur(0.05rem);

		color: #fff;
		/* 11/B2-regular */
		font-family: 'PingFang SC';
		font-size: 0.11rem;
		font-style: normal;
		font-weight: 400;

		& + .base-info-item {
			margin-left: 0.06rem;
		}
	}
}
</style>
